// extracted by mini-css-extract-plugin
export var externalLink = "_cc-0";
export var internalLinkLabel = "_cc-1";